import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './DriverRegisterLayout.scss';
import Paper from '@mui/material/Paper';
import { LogoColor } from '@assets/images';

const DriverRegisterLayout: FC = () => {
  const location = useLocation();
  const isSuccessPage = location.pathname.includes('/driver-register/success');

  return (
    <>
      <div className='AuthLayout'>
        <div className='logoNabla'>
          <img className='authLogo' src={LogoColor} alt='Logo' />
        </div>

        <div className='authContent'>
          {!isSuccessPage ? (
            <Paper>
              <Outlet />
            </Paper>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </>
  );
};

export default DriverRegisterLayout;
